import apiService from "../ApiService";

const endpoint = "/districts";

/**
 * Get all districts
 * Optional filters:
 * ?stateCode=KA
 * ?search=Dak
 */
export const getDistricts = async (params = {}) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const url = queryString ? `${endpoint}?${queryString}` : endpoint;

        const response = await apiService.getAll(url);
        return response;
    } catch (error) {
        console.error("Error fetching districts:", error);
        throw error;
    }
};

/**
 * Get district by ID
 */
export const getDistrictById = async (id) => {
    try {
        const response = await apiService.getById(endpoint, id);
        return response;
    } catch (error) {
        console.error(`Error fetching district with ID ${id}:`, error);
        throw error;
    }
};

/**
 * Create district
 */
export const createDistrict = async (data) => {
    try {
        const response = await apiService.create(endpoint, data);
        return response;
    } catch (error) {
        console.error("Error creating district:", error);
        throw error;
    }
};

/**
 * Update district
 */
export const updateDistrict = async (id, data) => {
    try {
        const response = await apiService.update(endpoint, id, data);
        return response;
    } catch (error) {
        console.error("Error updating district:", error);
        throw error;
    }
};

/**
 * Delete district
 */
export const deleteDistrict = async (id) => {
    try {
        const response = await apiService.remove(endpoint, id);
        return response;
    } catch (error) {
        console.error("Error deleting district:", error);
        throw error;
    }
};
